export default __webpack_public_path__ + "static/media/Discord.007003b8.png";